import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRangePicker, createStaticRanges, defaultStaticRanges } from 'react-date-range';
import { useEffect, useRef, useState } from 'react';
import "../../../components/common/styles.scss";

interface DateRangeProps {
  dateRange: {
    start: string;
    end: string;
  };
  setDateRange: (range: { start: string; end: string }) => void;
  label?: string;
  allowFutureDates?: boolean;
}

const CustomDateRange: React.FC<DateRangeProps> = ({
    dateRange,
    setDateRange,
    label,
    allowFutureDates = false,
}) => {
    const [errorMessage, setErrorMessage] = useState("");
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const calendarRef = useRef(null);

    // Convert the dateRange prop to the format expected by the DateRangePicker
    const ranges = [{
        startDate: dateRange.start ? new Date(dateRange.start) : new Date(new Date().setDate(new Date().getDate() - 6)),
        endDate: dateRange.end ? new Date(dateRange.end) : new Date(),
        key: 'selection',
    }];

    const formatDateForInput = (date: Date) => {
        // Use local date components to avoid timezone issues
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleSelect = (ranges: any) => {
        let { startDate, endDate } = ranges.selection;
        const today = new Date();
        
        // Ensure we're working with Date objects
        startDate = new Date(startDate);
        endDate = new Date(endDate);
        
        // In non-task tabs, block future dates. In tasks tab, allow them.
        const validStartDate =
            !allowFutureDates && startDate > today ? today : startDate;
        const validEndDate =
            !allowFutureDates && endDate > today ? today : endDate;
        
        setDateRange({
            start: formatDateForInput(validStartDate),
            end: formatDateForInput(validEndDate)
        });
    };

    const toggleCalendar = () => {
        setIsCalendarOpen(!isCalendarOpen);
    };

    const handleClickOutside = (event: any) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target)) {
            setIsCalendarOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const formatDate = (date: Date) => {
        // Use local date components for display
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const staticRanges = createStaticRanges(
        defaultStaticRanges.filter(
            (range) => range.label !== "This Month" && range.label !== "Last Month"
        )
    );

    return (
        <div style={{ position: "relative" }}>
            <div style={{ position: "absolute", top: "-9px", left: "5px", background: "white" }}><p style={{ margin: "0" }}>{label || "Select date"}</p></div>
            <div onClick={toggleCalendar} style={{ border: "1px solid #ccc", padding: "11px", borderRadius: "4px", cursor: "pointer", overflow: "hidden", fontSize: "12px" }}>
                {`${formatDate(ranges[0].startDate)} - ${formatDate(ranges[0].endDate)}`}
            </div>
            {isCalendarOpen && (
                <div
                    ref={calendarRef}
                    style={{
                        position: "absolute",
                        zIndex: 1000,
                        padding: "5px",
                        right: 0
                    }}
                >
                    <DateRangePicker
                        editableDateInputs={true}
                        onChange={handleSelect}
                        moveRangeOnFirstSelection={false}
                        ranges={ranges}
                        staticRanges={staticRanges}
                        maxDate={allowFutureDates ? undefined : new Date()}
                        showDateDisplay={false}
                    />
                </div>
            )}
        </div>
    );
};

export default CustomDateRange;